/** Page sizes the grid's own "Page size" menu offers, smallest first. */
export const AVAILABLE_PAGE_SIZES = [25, 50, 75, 100] as const;

export const MAX_PAGE_SIZE = Math.max(...AVAILABLE_PAGE_SIZES);
